import { render, staticRenderFns } from "./StatusTransaction.vue?vue&type=template&id=457143b0"
import script from "./StatusTransaction.vue?vue&type=script&lang=js"
export * from "./StatusTransaction.vue?vue&type=script&lang=js"
import style0 from "./StatusTransaction.vue?vue&type=style&index=0&id=457143b0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports